import _ from "lodash";
import {
  FETCH_INTENTS,
  CREATE_NEW_INTENT,
  BUILD_BOT,
  BOT_STATUS,
  DISABLE_INTENT,
  CLEAR_DISABLE_INTENT_RESPONSE,
  RE_ENABLE_INTENT,
  CLEAR_RE_ENABLE_INTENT_RESPONSE,
  TRIGGER_BUILD_BOT,
  TRIGGER_CHECK_BOT_STATUS,
  UPDATE_FALLBACK_INTENT,
  CLEAR_UPDATE_FALLBACK_INTENT_RESPONSE
} from "../actions/types";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_INTENTS:
      _.forEach(action.payload, intents => {
        _.forEach(intents, intent => {
          intent.visible = true;
        });
      });
      return {
        ...state,
        ...action.payload
      };
    case CREATE_NEW_INTENT:
      return {
        ...state,
        intentCreated: action.payload
      };
    case DISABLE_INTENT:
      return {
        ...state,
        disableIntentResponse: action.payload.response
      };
    case CLEAR_DISABLE_INTENT_RESPONSE:
      return _.omit(state, ["disableIntentResponse"]);
    case RE_ENABLE_INTENT:
      return {
        ...state,
        reEnableIntentResponse: action.payload.response
      };
    case CLEAR_RE_ENABLE_INTENT_RESPONSE:
      return _.omit(state, ["reEnableIntentResponse"]);

    case BUILD_BOT:
      return {
        ...state,
        botBuilt: action.payload
      };
    case BOT_STATUS:
      return {
        ...state,
        botStatus: action.payload
      };
    case TRIGGER_BUILD_BOT:
      return {
        ...state,
        botBuildTriggered: action.payload
      };
    case TRIGGER_CHECK_BOT_STATUS:
      return {
        ...state,
        checkBotStatusTriggered: action.payload
      };
    case UPDATE_FALLBACK_INTENT:
      return {
        ...state,
        updateFallbackIntentResponse: action.payload
      };
    case CLEAR_UPDATE_FALLBACK_INTENT_RESPONSE:
      return _.omit(state, ["updateFallbackIntentResponse"]);
    default:
      return state;
  }
}
